export const frontmatter = {
    "draft": false,
    "title": "Canales",
    "sidebar_group": "referencia",
    "sidebar_label": "Canales",
    "sidebar_order": 4
}

export const toc = []